import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseHttpService } from '@shared/services/base-http.service';
import { Response } from '@shared/models/response.model';
import { Event } from '@shared/models/event.model';
import { TableResponse } from '@shared/models/table-response.model';
import { EventComment } from '@shared/interfaces/event-comment.interface';

@Injectable({
  providedIn: 'root',
})
export class EventsServicePublic {
  constructor(public baseHttp: BaseHttpService) {}

  addParticipants(opt, type = 'general') {
    return this.baseHttp
      .post('/event/add-participant/' + type, opt)
      .pipe(map((resp) => resp as Response<TableResponse<Event[]>>));
  }

  getEvents(opt = ''): Observable<Response<Event[]>> {
    return this.baseHttp
      .get('/event/list' + opt)
      .pipe(map((resp) => resp.data as Response<Event[]>));
  }

  getEvent(id: number): Observable<Response<Event>> {
    return this.baseHttp.get('/event/' + id).pipe(map((resp) => resp as Response<Event>));
  }

  getNote(id: number, params: any): Observable<Response<TableResponse<EventComment[]>>> {
    return this.baseHttp
      .get('/event/comment/' + id, params)
      .pipe(map((resp) => resp as Response<TableResponse<EventComment[]>>));
  }

  createNote(pack: EventComment): Observable<Response<EventComment>> {
    return this.baseHttp
      .post('/event/comment', { event_comment: pack })
      .pipe(map((resp) => resp as Response<EventComment>));
  }
}
